function h(t, r) {
  const e = f(r);
  return "formatToParts" in e ? s(e, t) : u(e, t);
}
const c = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function s(t, r) {
  try {
    const e = t.formatToParts(r), n = [];
    for (let o = 0; o < e.length; o++) {
      const a = c[e[o].type];
      a !== void 0 && (n[a] = parseInt(e[o].value, 10));
    }
    return n;
  } catch (e) {
    if (e instanceof RangeError)
      return [NaN];
    throw e;
  }
}
function u(t, r) {
  const e = t.format(r), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(e);
  return [
    parseInt(n[3], 10),
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[4], 10),
    parseInt(n[5], 10),
    parseInt(n[6], 10)
  ];
}
const i = {}, d = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), m = d === "06/25/2014, 00:00:00" || d === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function f(t) {
  return i[t] || (i[t] = m ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), i[t];
}
export {
  h as tzTokenizeDate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/_lib/tzTokenizeDate/index.js
// module id = 1332
// module chunks = 41